// ======================================================================
// File Name       : EnterpriseConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const ENTERPRISE_LAYER_L0 = 0;
export const ENTERPRISE_LAYER_L1 = 1;
export const PRICE_PLAN = {
  OLD: 0,
  NEW: 1,
};
export const NEW_PRICE_PLAN_RESERVATION = '新料金プラン（予約中）';

export const BILLING_SYSTEM_REGISTER_FLAG_STATUS = {
  NOT_REGISTERED: 0,
  PENDING_REGISTERED: 1,
  REGISTERED: 2,
};

// sprint_20230508_tma #20 START
export const CREDIT_CHECKED_FLAG_STATUS = {
  UN_CONFIRMED: 0,
  NO_PROBLEM: 1,
  PROBLEM: 2,
};
// sprint_20230508_tma #20 END

export const LIVE_INIT_COST_STATUS = {
  NOT_BILLED: 0,
  PENDING_BILLING: 1,
  BILLED: 2,
};

// sprint_20230522_tma START
export const CANCEL_REASON = {
  REASON_1: '管理画面が使いづらい',
  REASON_2: '教材のコンテンツを用意できない',
  REASON_3: '育成効果が感じられない',
  REASON_4: 'LMS自体が必要無くなった',
  REASON_5: '価格が高い',
}
// sprint_20230522_tma END

// sprint_20230605_tma START
export const PAYMENT_TYPE = {
  CREDIT_CARD: 0,
  BANK_TRANSFER: 1,
  OPS: 2,
};
// sprint_20230605_tma START

// sprint_20230718_tma START
export const HIDDEN_STATUS = {
  SHOW_ALL: 0,
  KNOWLEDGE_BASE: 1,
  HIDE_ALL: 2,
};
// sprint_20230718_tma END
